import * as React from 'react';
import { Route, Switch } from 'react-router';
import Layout from '../../../layout/themes/Hooshmand/Layout';

import Home from './pages/Home';
 
import NotFound404 from './pages/customErrors/404NotFound';
import AccessDenied403 from './pages/customErrors/403AccessDenied';
import About from './pages/About';
import Products_IBGate from './pages/Products_IBGate';
import Contact from './pages/Contact';
import RequestDemo from '../../../components/CMSApp/RequestDemo';

export default () => (
   <Layout>
      <Switch>
         <Route exact path='/home' component={Home} />
         <Route exact path='/about' component={About} />
         <Route exact path='/contact' component={Contact} />
         <Route exact path='/products' component={Products_IBGate} />
         <Route exact path='/products/ibgate' component={Products_IBGate} />
          <Route exact path='/' component={Home} />
          <Route exact path='/RequestDemo' component={RequestDemo} /> 
         <Route path='/404' component={NotFound404} />
         <Route path='/403' component={AccessDenied403} />
         <Route component={Home} />
      </Switch>
   </Layout>
   //  </Layout>
);
